/**
 * @fileoverview POST handler for the "/banners/dismiss" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { bannersDismissCacheKeys } from "./constants";
import type { PostBannersDismissProps, BannersDismissResult } from "./types";

export const postBannersDismiss = reactQueryMutationAdapter(
  bannersDismissCacheKeys,
  (props: PostBannersDismissProps): Promise<BannersDismissResult> => {
    return fetch("/banners/dismiss", "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
